import VehicleItem from './VehicleItem'

export default VehicleItem;